import { useEffect, useRef, useState } from 'react';
import { loadGoogleMapsScript } from 'Utils/load-google-maps';

function debounce(fn, delay) {
  let timeoutId;
  return (...args) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => fn(...args), delay);
  };
}

function parseAddressComponents(place) {
  if (!place?.address_components) return {};

  const get = (type) =>
    place.address_components.find((c) => c.types.includes(type))?.long_name || "";

  return {
    address_street: `${get("street_number")} ${get("route")}`.trim(),
    address_suburb: get("locality"),
    address_state: get("administrative_area_level_1"),
    address_postcode: get("postal_code"),
  };
}


export default function useAutocompleteAddress(inputRef) {

  console.log("1. useAutocompleteAddress called with inputRef:", inputRef);
  const autocompleteRef = useRef(null);
  const [rawInput, setRawInput] = useState("");
  const [components, setComponents] = useState({});
  const [autoCompleteError, setAutoCompleteError] = useState(null);

//   useEffect(() => { //useEffect for testing only
//     console.log("useAutocompleteAddress components updated:", components);
//   }
// , [components]);

//   useEffect(() => { //useEffect for testing only
//     console.log("2. useAutocompleteAddress rawInput updated:", rawInput);
//   } , [rawInput]);

  useEffect(() => {
    let autocomplete;
    let service;

    loadGoogleMapsScript()
      .then((maps) => {
        if (!inputRef.current) return;

        autocomplete = new maps.places.Autocomplete(inputRef.current, {
          types: ["address"],
          componentRestrictions: { country: "au" },
        });

              // 👀 Create a prediction service for debugging
              service = new maps.places.AutocompleteService();

              // Watch input changes and log predictions
              inputRef.current.addEventListener("input", (e) => {
                const query = e.target.value;
                if (!query) return;

                service.getPlacePredictions(
                  { input: query, componentRestrictions: { country: "au" } },
                  (predictions, status) => {
                    console.log("🔮 Predictions:", predictions, "status:", status);
                  }
                );
              });

        const handlePlaceChanged = debounce(() => {
          const place = autocomplete.getPlace();
          if (!place.geometry) {
            // fallback: keep raw input
            setAutoCompleteError("AutoCompleteAddress Address not recognized, will use raw input.");
            setComponents({ address_street: rawInput });
            return;
          }

          setAutoCompleteError(null);
          setRawInput(place.formatted_address);
          setComponents(parseAddressComponents(place));

            // 👇 Hide lingering suggestions
          const pacContainers = document.querySelectorAll(".pac-container");
          pacContainers.forEach(el => (el.style.display = "none"));
        }, 300);

        autocomplete.addListener("place_changed", handlePlaceChanged);
        autocompleteRef.current = autocomplete;
      })
      .catch((err) => {
        setAutoCompleteError("FAutoCompleteAddress ailed to load Google Maps script");
        console.error(err);
      });

    return () => {
      if (autocompleteRef.current) {
        autocompleteRef.current.unbindAll();
      }
    };
  }, [inputRef]);

  const handleChange = (e) => {
    console.log("0. AutoCompleteAddress Input changed to:", e.target.value);
    setRawInput(e.target.value);
  };

  return { 
    components, 
    rawInput, 
    setRawInput,
    autoCompleteError, 
    handleChange 
  };
  
}


